import { useState } from 'react'
import { faqPourCasquette } from '../../content/faq'
import { useTheme } from '../../theme'

/**
 * Questions frequentes (prototype v7.4).
 *
 * Filtres de categorie en bandeau horizontal, puis un accordeon par categorie.
 * Seules les categories de la CASQUETTE active sont proposees : un client n'a
 * rien a faire des questions de commission producteur.
 *
 * `questionOuverte` permet d'arriver ici depuis la recherche de la page Aide,
 * la bonne question deja depliee.
 */
function AideFaqPage({ tc, ts, cardBg, hubMode, questionOuverte, onCta }) {
  const { isWeb3 } = useTheme()
  const cats = faqPourCasquette(hubMode)
  const catDeLaQuestion = questionOuverte
    ? cats.find((c) => c.items.some((it) => it.id === questionOuverte))?.id
    : null

  const [filtre, setFiltre] = useState(catDeLaQuestion || 'tout')
  const [ouverte, setOuverte] = useState(questionOuverte || null)

  const visibles = cats.filter((c) => filtre === 'tout' || c.id === filtre)

  return (
    <>
      {/* Filtres — bandeau qui deborde volontairement de la gouttiere */}
      <div className="flex gap-[7px] overflow-x-auto pb-1 -mx-4 px-4">
        {[{ id: 'tout', ico: '✳️', titre: 'Tout' }, ...cats].map((c) => {
          const actif = filtre === c.id
          return (
            <button key={c.id}
              onClick={() => { setFiltre(c.id); setOuverte(null) }}
              className={`flex-shrink-0 px-3 py-2 rounded-full text-xs font-bold whitespace-nowrap border ${
                actif ? 'text-creme border-transparent' : `${tc}`
              }`}
              style={actif
                ? { background: 'rgb(var(--c-green))' }
                : { background: isWeb3 ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.6)', borderColor: 'rgba(7,62,61,0.12)' }}>
              {c.ico} {c.titre}
            </button>
          )
        })}
      </div>

      {visibles.map((c) => (
        <div key={c.id} className="mt-4">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] mx-0.5 mb-2 text-teal">
            {c.ico} {c.titre}
          </p>
          <div className={`rounded-[22px] border overflow-hidden animate-fade-up ${cardBg}`}>
            {c.items.map((it, i) => {
              const ouv = ouverte === it.id
              return (
                <div key={it.id}
                  className={i < c.items.length - 1 ? `border-b ${isWeb3 ? 'border-white/5' : 'border-ink/[0.07]'}` : ''}
                  style={ouv ? { background: 'rgba(20,184,166,0.05)' } : undefined}>
                  <button onClick={() => setOuverte(ouv ? null : it.id)}
                    aria-expanded={ouv}
                    className="w-full flex items-start gap-3 px-[15px] py-3.5 text-left">
                    <span className={`flex-1 text-[13.5px] font-bold leading-snug ${tc}`}>{it.q}</span>
                    <span className={`text-[13px] flex-shrink-0 mt-0.5 transition-transform ${ouv ? 'text-teal' : ts}`}
                      style={{ transform: ouv ? 'rotate(90deg)' : 'none' }}>›</span>
                  </button>
                  {ouv && (
                    <div className="px-[15px] pb-[15px]">
                      <p className={`text-[12.5px] leading-[1.62] ${ts}`}>{it.r}</p>
                      {it.cta && (
                        <button onClick={() => onCta(it.cta)}
                          className="mt-3 px-4 py-2.5 rounded-full text-xs font-extrabold"
                          style={{ background: 'rgba(244,137,83,0.16)', color: '#b4551f' }}>
                          {it.cta.l} ›
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </>
  )
}

export default AideFaqPage
